<template>
    <span :class="`badge bg-${get_badge_type(time)}`">{{ time }}</span>
</template>

<script>

    export default {

        props: {
            time: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                internalTime: this.time,
            }
        },

        methods: {
            get_badge_type(time) {
                switch (time) {
                    case 'Any':
                        return 'secondary';
                    case 'AM':
                    case 'PM':
                        return 'info';
                    case 'Evening':
                    case 'Night':
                        return 'warning';
                    default:
                        return 'danger';
                }
            }
        },
    }
</script>
